module.exports = __webpack_public_path__ + "img/contrasena.721daf50.svg";